export default {
  auth: () => import("/app/web/layouts/auth.vue").then(m => m.default || m),
  default: () => import("/app/web/layouts/default.vue").then(m => m.default || m),
  collapse: () => import("/app/web/node_modules/.c12/gh_ezyostudio_tairo_v7KJU84kWI/layouts/collapse.vue").then(m => m.default || m),
  empty: () => import("/app/web/node_modules/.c12/gh_ezyostudio_tairo_l93sveT08N/layouts/empty.vue").then(m => m.default || m)
}